async function request(user, path = "", { method = "GET", checkoutId } = {}) {
  const token = await user?.getIdToken?.();
  if (!token) throw new Error("Sign in to manage your tracker subscription.");
  const base = String(process.env.REACT_APP_ENDPOINT || "").replace(/\/$/, "");
  const response = await fetch(`${base}/api/stats/billing${path}${checkoutId ? `?checkout_session_id=${encodeURIComponent(checkoutId)}` : ""}`, { method, headers: { Authorization: `Bearer ${token}` } });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || "Billing is temporarily unavailable. Please try again.");
  return data;
}
export const getTrackerBilling = (user, checkoutId) => request(user, "", { checkoutId });
export const startTrackerCheckout = (user) => request(user, "/checkout", { method: "POST" });
export const cancelTrackerSubscription = (user) => request(user, "/cancel", { method: "POST" });
export const openTrackerPortal = (user) => request(user, "/portal", { method: "POST" });
export function redirectToTrackerStripe(value) {
  const url = new URL(value);
  if (url.protocol !== "https:" || !["checkout.stripe.com", "billing.stripe.com"].includes(url.hostname) || url.username || url.password) throw new Error("Billing returned an invalid link. Please try again.");
  window.location.assign(url.toString());
}
